<template>
  <v-text-field
    v-if="showPhone"
    :value="value"
    :label="labelText"
    v-mask="phoneMask"
    :rules="rules"
    :error-messages="errorMessages"
    type="tel"
    prepend-icon="mdi-phone"
    required
    autocomplete="off"
    :loading="loading"
    @input="$emit('input', $event)"
    @change="$emit('change', $event)"
  ></v-text-field>
</template>

<script>
import { mask } from 'vue-the-mask';
import phoneMixin from '@/mixins/phoneMixin';

export default {
  name: 'FieldPhone',
  directives: { mask },
  mixins: [
    phoneMixin,
  ],
  props: {
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    errorMessages: {
      type: [Array, String],
      default: () => [],
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.showPhone = true;
    });
  },
  data() {
    return {
      phoneMask: '+380 (##) ###-##-##',
      showPhone: false,
    };
  },
  computed: {
    labelText() {
      if (!this.label) {
        return this.lang(this.$store, 'sap/listings.global.filter.hints.phone');
      }
      return this.label;
    },
  },
};
</script>

<style scoped>

</style>
